import {AntibodyEnforcedNamingStrategySpec} from 'antibodies/schema-configuration/AntibodyEnforcedDataModelConstants';
import {RegistryLabelingStrategy} from 'constants/RegistryConstants';
import {NamingStrategy} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  getEnabledLabelingStrategies,
  getEnabledLabelingStrategiesForSchema,
} from 'registry/labeling-strategies/LabelingStrategiesUtil';

export function getEnforcedNamingStrategies(
  enforcedNamingStrategySpec: AntibodyEnforcedNamingStrategySpec
): Array<RegistryLabelingStrategy> {
  return enforcedNamingStrategySpec.validNamingStrategies.map(
    (strategy) => RegistryLabelingStrategy[strategy]
  );
}

/**
 * Returns strategies from the spec that are deploy-enabled — the full list to render as checkboxes.
 * Strategies that require a name template but the schema lacks one are included here; they will be
 * shown as disabled and unchecked by the UI (mirroring LabelingStrategyConfiguration behaviour).
 */
export function getRegistryEnabledNamingStrategies(
  enforcedNamingStrategySpec: AntibodyEnforcedNamingStrategySpec
): Array<NamingStrategy> {
  const enabledStrategyValues = new Set<string>(getEnabledLabelingStrategies());
  return enforcedNamingStrategySpec.validNamingStrategies.filter((strategy) =>
    enabledStrategyValues.has(strategy)
  );
}

/**
 * Returns the subset of registry-enabled strategies that can actually be applied for this schema —
 * i.e. also compatible with whether the schema has a name template.
 * These are pre-checked and togglable; name-template strategies are excluded when hasNameTemplate is false.
 */
export function getSelectableNamingStrategies(
  enforcedNamingStrategySpec: AntibodyEnforcedNamingStrategySpec,
  hasNameTemplate: boolean
): Array<NamingStrategy> {
  const enabledStrategyValues = new Set<string>(getEnabledLabelingStrategiesForSchema(hasNameTemplate));
  return enforcedNamingStrategySpec.validNamingStrategies.filter((strategy) =>
    enabledStrategyValues.has(strategy)
  );
}

export function getShouldAddNamingStrategies(
  enforcedNamingStrategySpec: AntibodyEnforcedNamingStrategySpec,
  existingNamingStrategies: Array<RegistryLabelingStrategy> | null
): boolean {
  const enforcedStrategies = getEnforcedNamingStrategies(enforcedNamingStrategySpec);
  return (
    existingNamingStrategies == null ||
    !existingNamingStrategies.some((strategy) => enforcedStrategies.includes(strategy))
  );
}
